import { render, staticRenderFns } from "./StoreViewPay.vue?vue&type=template&id=60227e3b"
import script from "./StoreViewPay.vue?vue&type=script&lang=js"
export * from "./StoreViewPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports